import { CancellablePromise } from '../../types/cancellable-promise';
import { SLMap } from '../sl-map';
import { LayerRenderResult } from '../../types/layerrenderresult';
import { SLLayer, LayerTypeEnum } from '../sl-layer';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ResultsService, ResultMoment } from 'src/app/services/results.service';
import { BufferSrc } from '../buffersrc';
import { IClearable } from 'src/app/types/iclearable';
import { BufferInfo } from '../api-services/layer-api.service';
import { ColorClass } from 'src/app/types/color-class';
import { LabelStyle, LabelStyleString } from 'src/app/types/LabelStyle';
import * as turf from '@turf/turf';
import { ISelectionData, ISelectionInfo } from '../synchronizer';
import { MapDataAction } from '../map-actions/map_data-action';
import { InfoAction } from '../map-actions/info-action';
import { LngLat } from 'mapbox-gl';
import { BBOX, BBOXArray } from 'src/app/types/@types/sl-v-types';
import { BBoxToLngLatBounds } from 'src/app/services/geo.service';
import { ResultHistory } from '../result-history';


export class InputLayer extends SLLayer implements IClearable {
  public sourceLayer: SLLayer;
  private features: Array<any>;
  private subs: Array<SLLayer> = [];
  private vis = false;
  private labelVis = false;
  private selections: ISelectionInfo;
  private moment: ResultMoment;
  private inputBbox = null;

  public myOpacity = 1;
  public inputType: 'rect' | 'point' = null;
  private centerLat: string;
  private centerLon: string;
  public inheritLabels = false;
  private manualVis = true;
  private gids: string;

  public labelInfo: any = {
    labelField: '_sl_override_or_inherit_',
    labelStyleJSON: {
      font: 'RobotoBlack', size: 12, color: '#ffffff',
      align: 'center', outlinecolor: '#000000', outlinewidth: 2, shadowcolor: '#ededed',
      shadowsizex: 0, shadowsizey: 5, offsetx: 0, offsety: 20, position: 'lc'
    },
    inheritLabelStyle: false,
    inheritOnly: false,
    labelOverride: '',
    override: true,
    labelsOn: true
  };
  get layerOn(): boolean {
    if (this.parentSLLayer.layerOn === false) {
      return false;
    }
    return this.vis && this.manualVis;
  }
  set layerOn(isVis: boolean) {
    this.vis = isVis;
    if (isVis && this.touched) {

      this.Render(this.SLMap);
      this.touched = false;
    } else {
      if (this.overlayLayer === undefined) {
        this.Render(this.SLMap);
      } else {
        try {
          this.overlayLayer.UpdateVisibility();
          // map.ui.getLayer(this.overlayLayer.id);
          // map.ui.setLayoutProperty(this.overlayLayer.ui.id, 'visibility', (isOn && this.parentVis) ? 'visible' : 'none');
        } catch (e) {
          // this.Render(map);
          // do nothign;
        }
      }
    }
    this.visChange.emit({ layer: this });
  }

  SetLayerOn(isVis: boolean, map: SLMap = null) {
    map = map;
    this.manualVis = isVis;
    this.layerOn = isVis;
  }

  get labelsOn(): boolean {
    if (!this.parentSLLayer.labelsOn) {
      return false;
    }
    if (this.sourceLayer && (this.inheritLabels === true)) {
      return this.sourceLayer.labelsOn;
    }
    return this.labelVis;

  }
  set labelsOn(isVis: boolean) {
    this.labelVis = isVis;
  }
  get srcLabelsOn(): boolean {
    if (this.sourceLayer) {
      return this.sourceLayer.labelsOn;
    }
    return false;
  }

  get labelStyle(): LabelStyle {
    return this.sourceLayer.labelStyle;
  }
  set labelStyle(style: LabelStyle) {
    this.sourceLayer.labelStyle = style;
  }

  get opacity(): number {
    if (!!this.myOpacity) {
      return this.myOpacity;
    } else {
      return 0;
    }
  }
  set opacity(level: number) {
    this.myOpacity = level;
    this.overlayLayer.UpdateOpacity();
    this.change$.emit(this);

  }


  get queryAble(): boolean {
    if (this.searchable === false) {
      return false;
    }
    return [
      LayerTypeEnum.Vector.valueOf(),
      LayerTypeEnum.Relational.valueOf()
    ].indexOf(+this.type) > -1;
    // return (this.access >= LayerAccessLevel.Read);
  }
  public get canReplayQuery(): boolean {
    if (!this.moment || !this.moment.params) {
      return false;
    }
    const params: any = this.moment.params;
    const hasPointInput = !!params.centerLat && !!params.centerLon;
    const hasAreaInput = !!params.bbox;
    const hasFeatureInput = !!params.gids && !!(params.memoryLayer || params.featureLayer || this.sourceLayer);
    return hasPointInput || hasAreaInput || hasFeatureInput;
  }

  get parentLayer(): string {
    return 'results';
  }

  get searchable(): boolean {
    if ([
      LayerTypeEnum.Vector.valueOf(),
      LayerTypeEnum.Relational.valueOf()
    ].indexOf(+this.type) === -1) {
      return false;
    }
    return this.data.search_on === 1;
  }

  set searchable(isSearchable: boolean) {
    this.data.search_on = isSearchable === true ? 1 : 0;
  }
  get classification(): Array<ColorClass> {
    this.MakeClassificaiton();

    return this._classification;
  }
  constructor(map: ISLMap, resultsSvc: ResultsService) {
    super(null, map, null, null, resultsSvc);
    this.subs = this.subs;
    this.myOpacity = 1;
    this.abilities.show_labels = true;
    this.abilities.include_in_legend = true;
    this.abilities.allow_static_labels = true;
    // const me = this;
  }
  MakeClassificaiton() {
    const bufferSrc = this.moment.bufferSrc;
    let buffer;

    if (!!bufferSrc) {
      buffer = bufferSrc.value;
    } else {
      buffer = this.moment.params.distance;
    }

    const style = this.map.styles.resultInput;
    const styleSections = style.split(';');

    let strokeHex = Math.round(Number(styleSections[2]) * 255).toString(16);
    if (strokeHex.length === 1) {
      strokeHex = '0' + strokeHex;
    }
    let fillHex = Math.round(Number(styleSections[1]) * 255).toString(16);
    if (fillHex.length === 1) {
      fillHex = '0' + fillHex;
    }
    const hasStroke = Number(styleSections[2]) > 0;
    let stroke = hasStroke ? styleSections[0] : 'trans';
    stroke = stroke === 'trans' ? 'trans' : stroke;// + strokeHex;
    const hasFill = Number(styleSections[1]) > 0;
    let fill = hasFill ? styleSections[0] : 'trans';
    fill = fill === 'trans' ? 'trans' : fill;// + fillHex;
    if (this.inputType === 'rect' || this.inputType === null) {
      this._classification = [
        {
          crid: -1,
          criteria1: 'gid',
          criteria2: '>',
          criteria3: 0,
          description: 'Input Geometry',
          priority: 1,
          useFill: false,
          fill: 'trans',
          fillOpacity: 0,
          useStroke: hasStroke,
          stroke: (stroke),
          strokeOpacity: Number(styleSections[2]),
          field: '',
          operator: '',
          value: '',
          symbol: 'default',
          size: 4,
          useLabelStyle: this.labelsOn,
          labelStyle: this.labelStyle
        }, {
          crid: -2,
          criteria1: 'gid',
          criteria2: '>',
          criteria3: 0,
          description: 'Input Geometry',
          priority: 2,
          useFill: hasFill,
          fill: (fill),
          fillOpacity: Number(styleSections[1]),
          useStroke: false,
          stroke: 'trans',
          strokeOpacity: 0,
          field: '',
          operator: '',
          value: '',
          symbol: 'default',
          size: 4,
          useLabelStyle: false,
          labelStyle: ''
        }
      ];
    } else {
      this._classification = [
        {
          crid: -1,
          criteria1: 'gid',
          criteria2: '>',
          criteria3: 0,
          description: 'Input Geometry',
          priority: 1,
          useFill: false,
          fill: 'trans',
          fillOpacity: 0,
          useStroke: true,
          stroke: '#000000',
          strokeOpacity: 100,
          field: '',
          operator: '',
          value: '',
          symbol: 'cross_fnt',
          size: 5,
          useLabelStyle: false,
          labelStyle: ''
        }/*, {
					crid: -2,
					criteria1: '',
					criteria2: '',
					criteria3: '',
					description: 'Input Geometry',
					priority: 2,
					useFill: true,
					fill: '#000000',
					fillOpacity: 100,
					useStroke: false,
					stroke: 'trans',
					strokeOpacity: 0,
					field: '',
					operator: '',
					value: '',
					symbol: 'default',
					size: 4,
					useLabelStyle: false,
					labelStyle: ''
				}
				*/
      ]
    }
  }
  private GetReplayBuffer(): BufferSrc | null {
    const currentBuffer = InfoAction.bufferSrc;
    if (currentBuffer && Number(currentBuffer.value) !== 0) {
      return currentBuffer;
    }
    return null;
  }
  private HandleReplayResult(result: any, params: any, context: 'query' | 'query-by-feature' | 'roi-query', bufferSrc: BufferSrc | null) {
    if (!!result?.centroid) {
      this.map.component.SetMarker({ lngLat: result.centroid });
    }
    this.resultsSvc.SetResults(
      result,
      context,
      params,
      'query',
      bufferSrc ?? undefined,
      true,
      ResultHistory.LATEST_ID
    );
  }
  SetSelections(data: ISelectionData, inputType: 'rect' | 'point' = null) {
    let reswatch = false;
    this.inputType = (inputType !== null) ? inputType : ((!!data?.moment?.params?.inputType) ? data.moment.params.inputType : null);
    const sameMoment = !!this.moment && !!this.moment?.id && (data.moment?.id === this.moment?.id);
    const sameLayer = !!this.selections && this.selections?.layer && this.sourceLayer && (data.selections?.layer === this.sourceLayer);
    const isPtOrROI = ['rect', 'point'].indexOf(this.inputType) > -1;
    if (!(sameMoment && isPtOrROI)) {
      reswatch = true;
      if (!this.resultsSvc.CompareSelections(this.selections, data.selections)) {
        this.touched = true;
      }

    }

    this.selections = data?.selections;
    this.moment = data?.moment;
    this.ShowOrHide();
    if (!this.enabled) {
      this.Clear();
    } else {
      this.Render();
      if (reswatch) {
        this.UpdateLegend();
      }
    }
    MapDataAction.UpdateLayerPropertyView(this);
    this.legendChange.emit({ layer: this });
  }
  SetLabeling(labelData: any) {

  }
  ShowOrHide() {
    if (!this.selections) {
      this.enabled = false;
      this.layerOn = false;
      this.layerOn = this.enabled;
      return;
    }
    if (this.parentSLLayer.layerOn === false) {
      this.enabled = false;
      this.layerOn = false;
      return;
    }
    if (!!this.selections.layer) {
      if (!!this.moment) {
        if (!!this.moment.params) {
          const params: any = this.moment.params;
          this.gids = null;
          this.features = [];
          if (!!params.memoryLayer) {
            this.sourceLayer = this.map.GetLayerById('' + params.memoryLayer, false);
            this.data = this.sourceLayer.CloneData();
            this.styles = JSON.parse(JSON.stringify(this.sourceLayer.SLMap.styles));
            this.icon = this.icon;
            if (!!params.gids) {
              this.gids = params.gids;
            }
          }
          this.inputBbox = null;
          const bufferSrc = this.moment.bufferSrc;
          let buffer;

          if (!!bufferSrc) {
            buffer = bufferSrc.value;
          } else {
            buffer = this.moment.params.distance;
          }

          if (!!this.inputType) {
            this.sourceLayer = this.selections.layer;
            this.data = this.sourceLayer.CloneData();
            this.MakeClassificaiton();
            let styles: any = '';
            if (!(!!params.gids)) {
              styles = JSON.parse(JSON.stringify(this._classification));
              this.styles = { criteria: JSON.stringify(this._classification) };
            } else {
              styles = JSON.parse(JSON.stringify(this.map.styles));
              styles.selected = styles.resultInput;
              delete styles.unselected;
              delete styles.resultInput;
              this.styles = styles;
              if (this.inputType == null) {
                this.gids = '1';
              }
            }
            switch (this.inputType) {
              case 'rect':
                styles = { criteria: JSON.stringify(this._classification) };
                const styles2 = JSON.parse(JSON.stringify(this.map.styles));
                if (styles2.resultInput.indexOf('inherited')) {
                  const style = styles2.resultInput.split(';');
                  style.pop();
                  styles.selected = style.join(';');
                } else {
                  styles.selected = styles2.resultInput;
                }
                this.styles = styles;
                this.inputBbox = params.bbox;
                break;
              case 'point':
                styles = { criteria: JSON.stringify(this._classification) };
                const styles3 = JSON.parse(JSON.stringify(this.map.styles));
                if (styles3.resultInput.indexOf('inherited')) {
                  const style = styles3.resultInput.split(';');
                  style.pop();
                  styles.selected = style.join(';');
                } else {
                  styles.selected = styles3.resultInput;
                }

                this.styles = styles;
                this.centerLat = null;
                if (!!params.centerLat) {
                  this.centerLat = params.centerLat;
                }
                this.centerLon = null;
                if (!!params.centerLon) {
                  this.centerLon = params.centerLon;
                }
                if ((this.centerLat === null) && (this.centerLat === null)) {
                  let [minX, minY, maxX, maxY] = params.bbox.split(',');
                  minX = Number(minX);
                  minY = Number(minY);
                  maxX = Number(maxX);
                  maxY = Number(maxY);
                  const poly = turf.polygon([[
                    [minX, maxY],
                    [minX, minY],
                    [maxX, minY],
                    [maxX, maxY],
                    [minX, maxY]]
                  ], { name: 'poly1' });
                  const pt = turf.centroid(poly);
                  const [lon, lat] = pt.geometry.coordinates;
                  this.centerLat = '' + lat;
                  this.centerLon = '' + lon;
                }

                break;
            }


            this.enabled = true;
            this.layerOn = this.enabled;
            if (!(!!this.moment.params.gids)) {
              return;
            }
          }
          if (!!this.moment.params.gids) {
            const gids = this.moment.params.gids.split(',');
            this.features = gids;
            this.enabled = true;
            this.layerOn = this.enabled;
            return;
          }

        }
      }
    }
    this.enabled = false;
    this.layerOn = false;
    this.layerOn = this.enabled;

  }
  ShowResults(layer: SLLayer, features: Array<any>, styles: any) {
    layer = features = styles = null;
    /*
    this.sourceLayer = layer;
    this.data = layer.CloneData();
    this.enabled = features.length > 0;
    this.features = features;
    this.styles = styles;
    this.layerOn = this.enabled;
    this.labelVis = this.sourceLayer.labelsOn;
    this.labelAttribute = this.sourceLayer.labelAttribute;
    this.enabled = false;
    if (this.labelAttribute === 'default') {
      if (!!this.layerAttributes) {
        if (!!this.layerAttributes.length) {
          if (this.layerAttributes.length > 0) {
            this.labelAttribute = this.layerAttributes[0].name;
            this.enabled = true;
          }
        }
      }
    }
    if (!this.enabled) {
      this.Clear();
      this.layerOn = false;
    } else {
      this.layerOn = true;
      this.Render(null);
    }
    */

  }

  Clear() {
    this.features = [];
    this.overlayLayer.Clear();
    this.vis = false;
    this.enabled = false;
  }
  ClearImage() {
    this.overlayLayer?.Clear();
  }

  get overlayId(): string {
    return this.overlayLayer.id;
  }

  get defaultCriteria(): Array<any> | null {
    if (this.isPLayer === false) {
      return null;
    }
    return this.data.criteria;
  }
  get description(): string {
    return 'Features used as search input for spatial matching';
  }
  set description(desc: string) {
    desc = null;
    return;
  }

  get id(): string {
    return 'inputFeatures';
  }
  get icon(): string {
    switch (this.inputType) {
      case 'point':
        return SLLayer.GetIcon('point')
      case 'rect':
        return SLLayer.GetIcon('polygon');
      default:
        return super.icon;

    }
  }
  set icon(newIcon: string) {
    if (!!this.inputBbox) {
      return;
    }
    super.icon = newIcon;
  }



  get renderId() {
    return this.sourceLayer.identifier;
  }

  get plid(): string {
    return 'inputFeatures';
  }
  get name(): string {
    return 'Input Features';
  }
  set name(name: string) {
    name = name;
    return;
  }
  get geom(): string {
    if (!!this.data) {
      return this.data.geom;
    }
    return '';
  }
  get searchtip(): string {
    return (this.data.searchtip === null) ? '' : this.data.searchtip;
  }
  set searchTip(tip: string) {
    this.data.searchTip = (tip === '') ? null : tip;
  }

  get type(): number {
    return LayerTypeEnum.Virtual_Input;
  }
  set type(layerType: number) {
    layerType = layerType;
  }
  get typeString(): string {
    return LayerTypeEnum[this.type];
  }
  get identifier() {
    if (this.isPLayer === true) {
      return this.plid;
    }
    return this.id;
  }

  get subLayers(): Array<any> {
    return [];

  }
  get subSLLayers(): Array<SLLayer> {
    return [];
  }
  get hasSubLayers(): boolean {
    return false;
  }



  Render(map: ISLMap = null, force: boolean = false) {
    if (force === true) {
      // this.touched = true;
    }
    if (!this.layerOn && !this.touched && !this.parentVis) {
      return;
    }
    if (this.sourceLayer === undefined) {
      return;
    }
    if (map === null) {
      if (this.SLMap === undefined) {
        return;
      }
      map = this.SLMap;
    }

    if (this.isPLayer) {
      if (this.vis === false || this.enabled === false) {
        this.Clear();
        this.touched = true;
        this.rendered.emit({ id: this.identifier, isPLayer: this.isPLayer, status: 'ok' });
        return;
      }
    }
    this.rendering.emit({ id: this.identifier, isPLayer: this.isPLayer });
    const handler = (result: LayerRenderResult) => {
      if (result === undefined) {
        this.Clear();
        this.rendered.emit({
          id: this.identifier,
          isPLayer: this.isPLayer,
          status: 'problem',
          error: 'There was a problem retrieving layer :' + this.name
        });
        return;
      }
      this.overlayLayer.HandleRenderResult(result);

    };
    if (this.isPLayer === true) {

      this.styles = JSON.parse(JSON.stringify(this.styles));
      if (!!map.styles.resultInput) {
        this.styles.selected = map.styles.resultInput;
        switch (this.inputType) {
          case 'point':
          case 'rect':
            if (this.styles.selected.indexOf('inherit') > -1) {
              const style = this.styles.selected.split(';');
              style.pop();
              this.styles.selected = style.join(';');
            }
            break;
          default:
          // do nothing
        }
        if (!!this.styles.resultInput) {
          delete this.styles.resultInput;
        }

      }

      if (!!this.styles.unselected) {
        delete this.styles.unselected;
      }



      // this.styles.selected = styles.selected;
      let bufferInfo: BufferInfo = null;;
      if (!!this.inputBbox) {
        bufferInfo = {
          buffer: null,
          gids: (!!this.gids) ? this.gids : null,
          inputBbox: this.inputBbox,
          inputType: this.inputType
        }

      } else if (!!this.centerLat && !!this.centerLon) {
        bufferInfo = {
          buffer: null,
          gids: (!!this.gids) ? this.gids : null,
          inputType: this.inputType,
          centerLon: this.centerLon,
          centerLat: this.centerLat
        }
      }

      let labelsOn = this.labelInfo.labelsOn;
      let labelStyle = this.labelStyle;
      let labelValue = null; // this.sourceLayer.labelOverride;
      if (this.labelInfo.override === true) {
        if (this.labelInfo.labelField === '_sl_override_' || !this.gids) {
          labelsOn = this.labelInfo.labelsOn;// this.labelInfo.labelField === '_sl_override_';
          labelStyle = this.labelInfo.labelStyleJSON;
          labelValue = this.labelInfo.labelOverride;
          this.labelAttribute = null;// this.labelInfo.labelField;
        } else {
          this.labelAttribute = this.sourceLayer.labelAttribute;
        }
      } else {
        this.labelAttribute = this.sourceLayer.labelAttribute;
      }
      if ((this.labelInfo.inheritLabelStyle === true)) {
        labelStyle = this.sourceLayer.labelStyle;
      }
      this.SLMap.component.layerAPI.RenderProjectLayerById(
        this,
        map,
        this.features,
        this.styles, labelsOn,
        bufferInfo,
        JSON.stringify(labelStyle),
        labelValue).then(handler);
      return;
    }
    this.styles.unormal = '1';
    const promise: CancellablePromise | void = this.SLMap.component.layerAPI.RenderLayerById(
      this.sourceLayer.identifier,
      map,
      this.features,
      this.styles,
      this.labelsOn,
      this.sourceLayer.labelStyleJSON as LabelStyleString);
    if (promise) {
      promise.then(handler);
    }
    this.touched = false;
  }

  GetFeatures(): Array<any> {
    return this.features;
  }
  HasFeatures(): boolean {
    if (!this.selections) {
      return false;
    }
    if (!this.selections.features) {
      return false;
    }
    return this.selections.features.length > 0;
  }
  ZoomToFeatures() {
    /*this.SLMap.component.HandleToolAction({
      action: 'info/zoom-to-features',
      layer: this.sourceLayer.id,
      features: this.features.join(',')
    });*/

    if (!this.moment?.params) return;
    if (this.inputType === 'rect' || this.inputType === null) {
      const bbox = this.moment.params?.bbox;
      if (!bbox) return;
      const bounds = BBoxToLngLatBounds(bbox as BBOX);
      this.SLMap.ui.fitBounds(bounds, { animate: false });
    } else {
      const point = new LngLat(Number(this.moment.params.centerLon), Number(this.moment.params.centerLat));

      this.SLMap.ui.jumpTo({ center: point })
    }
  }
  Query() {
    if (!this.canReplayQuery || !this.map?.component) {
      return;
    }
    this.ClearImage();
    const slMap = this.map as SLMap;
    const mapComponent = slMap.component;
    const params: any = this.moment!.params;
    const visOnly = !mapComponent.queryAllSearchableLayers;
    const bufferSrc = this.GetReplayBuffer();
    const layers = slMap.layerListService.GetSearchableLayers(slMap.layers, visOnly);

    if (!!params.gids) {
      const featureLayer = params.memoryLayer ?? params.featureLayer ?? this.sourceLayer?.id;
      const gids = Array.isArray(params.gids) ? params.gids : ('' + params.gids).split(',').filter((gid) => gid !== '');
      if (!!featureLayer && gids.length > 0) {
        const qPromise = mapComponent.layersAPI.QueryLayers(
          slMap,
          null,
          layers,
          Infinity,
          bufferSrc ?? undefined,
          'false',
          featureLayer,
          gids,
          false,
          visOnly
        );
        if (!!qPromise) {
          qPromise.promise.then((result) => {
            this.HandleReplayResult(result, qPromise.params, 'query-by-feature', bufferSrc);
          });
        }
        return;
      }
    }

    if (!!params.centerLat && !!params.centerLon) {
      const mapPoint = new LngLat(Number(params.centerLon), Number(params.centerLat));
      const qPromise = mapComponent.layersAPI.QueryLayers(
        slMap,
        mapPoint,
        layers,
        Infinity,
        bufferSrc ?? undefined,
        'false',
        null,
        null,
        false,
        visOnly
      );
      if (!!qPromise) {
        qPromise.promise.then((result) => {
          this.HandleReplayResult(result, qPromise.params, 'query', bufferSrc);
        });
      }
      return;
    }

    if (!!params.bbox) {
      const [minX, minY, maxX, maxY] = ('' + params.bbox).split(',').map(Number);
      const bbox = [minX, minY, maxX, maxY] as [number, number, number, number];
      const qPromise = mapComponent.layersAPI.QueryLayersByBbox(
        slMap,
        bbox,
        layers,
        Infinity,
        bufferSrc ? bufferSrc.value : undefined,
        'false',
        visOnly
      );
      qPromise.promise.then((result) => {
        this.HandleReplayResult(result, qPromise.params, 'roi-query', bufferSrc);
      });
    }
  }
  SetLabelInfo(info: any) {
    this.labelInfo = info;
  }
  GetLabelInfo(): any {
    return this.labelInfo;
  }
  IsVirtual(): boolean {
    return true;
  }

  get fontIcon() {
    return '';
  }
  GetColor() {
    return this.map.styles.resultInput;
  }
  GetSourceLayer() {
    return this.sourceLayer;
  }


}
